import React, { useEffect, useState } from "react";
import * as d3 from "d3";
import "./Graph.css";
import { generateConstants } from "./Data_Processing";
import { drawSvg } from "./Svg";
import { drawLinks } from "./Links";
import { calculateClusters } from "./Animations";
import { createNodes, processNodes, drawNodes } from "./Nodes";

const Graph = ({
  thoughts,
  containerRef,
  setSidebar,
  isMobile,
  selection,
  setThoughtsLoaded,
  setImgRatio,
}) => {
  const [constants, setConstants] = useState({});
  const [windowResizing, setWindowResizing] = useState(false);

  const redraw = () => {
    (async () => {
      setThoughtsLoaded(false);
      // check if mobile dimensions

      let out = await createNodes(thoughts);
      createForceGraph(out.data, out.labelDict, selection);
    })();

    const createForceGraph = (data, labelDict, selection) => {
      data = processNodes(data, constants);
      const { clusters, clusterCenters } = calculateClusters(
        data,
        labelDict,
        constants
      );
      const sharedFeatures = {
        containerRef,
        selection,
        data,
        clusters,
        clusterCenters,
        setSidebar,
        setImgRatio,
      };

      let svg = drawSvg(constants, sharedFeatures);
      drawLinks(svg, sharedFeatures);
      drawNodes(svg, constants, sharedFeatures);
      setThoughtsLoaded(true);
    };
  };

  useEffect(() => {
    setConstants(
      generateConstants(isMobile, window.innerWidth, window.innerHeight)
    );
  }, [isMobile, thoughts]);

  useEffect(() => {
    if (!thoughts || !constants.width) return;
    redraw();
  }, [constants, selection]);

  useEffect(() => {
    if (!thoughts || !constants.width) return;
    let timeout;

    const handleResize = () => {
      clearTimeout(timeout);
      setWindowResizing(true);
      setThoughtsLoaded(false);

      timeout = setTimeout(() => {
        setWindowResizing(false);
        if (window.innerWidth < 500) {
          setConstants(
            generateConstants(true, window.innerWidth, window.innerHeight)
          );
        } else {
          setConstants(
            generateConstants(false, window.innerWidth, window.innerHeight)
          );
        }
      }, 200);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [thoughts, containerRef, isMobile]);

  return <div />;
};

export default Graph;
